import { render, staticRenderFns } from "./VExpert.vue?vue&type=template&id=16df2754&lang=pug"
import script from "./VExpert.vue?vue&type=script&lang=ts"
export * from "./VExpert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports